import { PartsBasketCreds } from '../security/interfaces'
import {
  CartButtonValues,
  type IParsedGoShoppingParams,
} from './types/partsBasketSpec'

class EmbeddedConfigManager {
  private localInventory = false

  private partsBasketCreds?: PartsBasketCreds

  private cartButton: CartButtonValues | undefined = CartButtonValues.BOTH

  // if the app is launched from aesServer integration.
  private aesServer = false

  private checkAvailabilityRedirect: boolean
  private partsBasket: string
  private service: string | undefined

  public init = (data: IParsedGoShoppingParams): void => {
    // To debug integrations opening the app by passing query params.

    // eslint-disable-next-line no-console
    console.log('Initialized with URI: ', window.location.href, data)

    if (!data || !data.partnerId) {
      throw new Error('Partner ID not provided')
    }

    this.partsBasketCreds = {
      partnerId: data.partnerId,
      sellerId: data.sellerId,
      buyerId: data.buyerId,
    }

    this.localInventory = data.localInventory
    this.cartButton = data.cartButton
    this.partsBasket = data.partsBasket
    this.aesServer = data.aesServer
    this.service = data.service

    this.checkAvailabilityRedirect = data.checkAvailabilityRedirect

    // TODO: Need to revisit the cart only mode once discussions resume with shopware.
    if (data.checkAvailabilityRedirect) {
      this.cartButton = CartButtonValues.ORDER
    }
  }

  public getPartsBasketCreds = (): PartsBasketCreds => {
    if (!this.partsBasketCreds) {
      throw new Error('Credentials not found.')
    }
    return this.partsBasketCreds
  }

  get isAesServer(): boolean {
    return this.aesServer
  }

  get isLocalInventoryEnabled(): boolean {
    return this.localInventory
  }

  get cartButtonValue(): CartButtonValues | undefined {
    return this.cartButton
  }

  get isCheckAvailabilityRedirect(): boolean {
    return this.checkAvailabilityRedirect
  }

  get partsBasketString(): string {
    return this.partsBasket
  }

  get partsBasketService(): string | undefined {
    return this.service
  }
}

export const embeddedConfigManager = new EmbeddedConfigManager()
